<style>
.v-text-field input {
  font-size: 0.75em;
}
</style>

<template>
  <v-card flat tile>
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-toolbar flat color="white">
      <v-toolbar-title>
        <v-icon class="mb-1">mdi-filter</v-icon>
        Filtros
      </v-toolbar-title>

      <v-divider class="mx-4" inset vertical></v-divider>
      <v-col class="md-2">
        <v-text-field
          label="AWB"
          v-model="paramNumAwb"
          @click:append="cargarHistorial()"
          @keyup.enter="cargarHistorial()"
          append-icon="mdi-magnify"
          class="mt-2 mx-4"
          clearable
        >
        </v-text-field>
      </v-col>

      <v-col class="md-2">
        <v-text-field
          label="GUIA HIJA"
          v-model="paramNumHawb"
          @click:append="cargarHistorial()"
          @keyup.enter="cargarHistorial()"
          append-icon="mdi-magnify"
          class="mt-2 mx-4"
          clearable
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        small
        v-if="puedoDescargar"
        color="primary"
        @click="descargarGuias()"
      >
        <v-icon>mdi-download </v-icon> Descargar
      </v-btn>
    </v-toolbar>
    <div>
      <v-data-table
        :headers="headerHistorial"
        :options.sync="options"
        :items="lista"
        :itemsPerPage="itemsPerPage"
        :server-items-length="totalItems"
        class="elevation-1"
        :show-select="puedoDescargar"
        v-model="seleccion"
        item-key="HAWB_ID"
        hide-default-footer
      >
        <template v-slot:item.opciones="{ item }">
          <v-btn
            color="success"
            icon
            small
            text
            label="Descargar guía hija PDF"
            v-if="puedoDescargar"
            @click="descargar(item)"
          >
            <v-icon color="primary">mdi-download</v-icon>
          </v-btn>

          <v-btn
            small
            icon
            text
            class="mx-1"
            label="Ver reserva"
            @click="verReserva(item)"
          >
            <v-icon color="primary">mdi-eye</v-icon>
          </v-btn>
        </template>

        <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>

      <!-- FORM RESERVA-->
      <v-dialog v-model="dialogReserva" persistent max-width="660px">
        <v-card>
          <v-card-title>
            <v-icon class="mx-2">mdi-airplane-edit</v-icon>
            <span class="headline"
              >Reserva
              <span style="font-size: 11pt; font-weight: bold"
                >| {{ formatoFecha(reserva.FECHA) }}</span
              ></span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="formReserva">
                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.FUE"
                      label="DAE"
                    >
                    </v-text-field>
                    <!-- <v-autocomplete :rules="_fechaDae" :disabled="soloVer" v-model="reserva.FUE_ID" small
                      item-text="DAE_DEST" item-value="FUE_ID" :items="daes" clearable label="Seleccione una DAE">

                      <template v-slot:item="data">

                        <template>

                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.FUE"></v-list-item-title>
                            <v-list-item-subtitle v-html="data.item.DESTINO"></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </template>

                    </v-autocomplete> -->
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="px-1 py-5" cols="14">
                    <v-label class="px-12 py-4">Variedades</v-label>
                    <span v-for="i in reserva.VARIEDADES">
                      <v-chip
                        small
                        class="ma-1"
                        :color="colorVariedad(i.VALOR_PARAM)"
                      >
                        {{ i.VALOR_PARAM }}
                      </v-chip>
                    </span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0 pb-0" cols="1.5">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.fulles"
                      label="Fulles"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="1.5">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.mitades"
                      label="Mitades"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="1.5">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.tercios"
                      label="Tercios"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="1.5">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.cuartos"
                      label="Cuartos"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="1.5">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.sextos"
                      label="Sextos"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="1.5">
                    <v-text-field
                      :readonly="soloVer"
                      v-model="reserva.octavos"
                      label="Octavos"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="2">
                    <v-text-field
                      :disabled="soloVer"
                      v-model="reserva.dieciseisavos"
                      label="Dieciseisavos"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0 pb-0" cols="12">
                    <v-textarea
                      :readonly="soloVer"
                      rows="2"
                      v-model="reserva.OBSERVACIONES"
                      label="Observaciones"
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center">
              &nbsp;
              <v-btn small @click="dialogReserva = false">
                <v-icon>mdi-cancel</v-icon> Cerrar
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";
import Vue from "vue";

export default {
  name: "HistorialEmbarquesFincaComponent",

  data: () => ({
    headerHistorial: [
      { text: "Opciones", align: "center", value: "opciones" },
      { text: "HAWB", align: "start", value: "NUM_GUIA_FINCA" },
      { text: "AWB", align: "start", value: "AWB" },
      { text: "Destino", align: "start", value: "DEST_CIUDAD" },
      { text: "Cliente final", align: "start", value: "SCLIENTE_NOMBRE" },
      { text: "Cajas", align: "start", value: "CAJAS_CONF" },
      { text: "Piezas", align: "start", value: "PIEZAS_CONF" },
      { text: "Fecha de vuelo", align: "start", value: "FECHA_MANIF" },

      { text: "DAE", align: "start", value: "FUE" },
    ],
    lista: [],
    paramNumAwb: "",
    paramNumHawb: "",
    options: {},
    destinoId: "",
    cabeceraId: "",
    overlay: false,
    totalItems: 0,
    currentPage: 1,
    pageCount: 1,
    itemsPerPage: 20,
    seleccion: [],
    puedoDescargar: false,
    dialogReserva: false,
    soloVer: true,
    reserva: {
      VARIEDADES: [],
      FUE_ID: "",
      FUE: "",
      CABECERA_ID: "",
      FINCA_ID: "",
      HCOORD_ID: "",
      CNEE_ID: "",
      RATE: "",
      AWB: "",
      FECHA: "",
      COMER_ID: "",
      SCLIENTE_ID: "",
      full: "0",
      mitades: "0",
      tercios: "0",
      cuartos: "0",
      sextos: "0",
      octavos: "0",
      dieciseisavos: "0",
      OBSERVACIONES: "",
    },
  }),
  watch: {},
  computed: {
    ...mapState("master", ["user", "loadingTable"]),

    ...mapState("access", ["loggedIn", "idActionsRol", "historialEmbarques"]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setLoadingBtn",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    formatoFecha(fecha) {
      moment.locale("es");
      return moment(fecha).format("ddd D - MMMM - Y");
    },

    cargarHistorial() {
      this.setLoadingTable(true);

      this.lista = [];

      this.setUrl("api/historial-embarques");
      this.requestApi({
        method: "GET",
        data: {
          pageCount: this.pageCount,
          itemsPerPage: this.itemsPerPage,
          page: this.currentPage,
          sortBy: this.options.sortBy[0],
          sortDesc: this.options.sortDesc[0],
          paramNumAwb: this.paramNumAwb,
          paramNumHawb: this.paramNumHawb,
        },
      })
        .then((res) => {
          this.lista = res.data.lista;
          this.totalItems = res.data.totalItems;
          this.pageCount = res.data.pageCount;
        })
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    descargar(item) {
      this.setUrl("api/importar-hawb");
      this.requestApi({
        method: "POST",
        data: {
          hawbId: item.HAWB_ID,
        },
      })
        .then((res) => {
          let a = document.createElement("a");
          a.href = "data:" + res.data.ContentType + ";base64," + res.data.datos;
          a.download = res.data.nombreArchivo;
          a.click();
        })
        .then(() => {});
    },
    descargarGuias() {
      this.setUrl("api/importar-hawb-lote");
      let hawbs = [];
      for (let i = 0; i < this.seleccion.length; i++) {
        hawbs.push(this.seleccion[i].HAWB_ID);
      }

      this.requestApi({
        method: "POST",
        data: {
          hawbIds: hawbs,
        },
      })
        .then((res) => {
          let a = document.createElement("a");
          a.href = "data:" + res.data.ContentType + ";base64," + res.data.datos;
          a.download = res.data.nombreArchivo;
          a.click();
        })
        .then(() => {});
    },
    verReserva(item) {
      this.setUrl("api/cargar-reserva");
      this.requestApi({
        method: "GET",
        data: {
          detalle_id: item.DETALLE_ID,
        },
      })
        .then((res) => {
          console.log(res.data.reserva);
          this.reserva = {
            DETALLE_ID: res.data.reserva.DETALLE_ID,
            VARIEDADES: item.params_coord,
            FUE_ID: res.data.reserva.FUE_ID,
            CABECERA_ID: res.data.reserva.CABECERA_ID,
            FINCA_ID: res.data.reserva.FINCA_ID,
            HCOORD_ID: item.HCOORD_ID,
            CNEE_ID: res.data.reserva.CLIENTE_ID,
            RATE: res.data.reserva.RECARGO_COMBUS,
            AWB: res.data.reserva.AWB,
            FECHA: res.data.reserva.FECHA,
            COMER_ID: res.data.reserva.COMER_ID,
            SCLIENTE_ID: res.data.reserva.SCLIENTE_ID,
            fulles: res.data.reserva.fulles,
            mitades: res.data.reserva.mitades,
            tercios: res.data.reserva.tercios,
            cuartos: res.data.reserva.cuartos,
            sextos: res.data.reserva.sextos,
            octavos: res.data.reserva.octavos,
            dieciseisavos: res.data.reserva.dieciseisavos,
            OBSERVACIONES: res.data.reserva.OBSERVACIONES,
            FUE: res.data.reserva.FUE,
          };
          this.dialogReserva = true;
        })
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    handlePageChange() {
      this.cargarHistorial();
    },
  },
  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("DESCARGAR GUIAS HIJAS");
    this.cargarHistorial();
    console.log(this.idActionsRol);

    if (this.idActionsRol.find((e) => e === "DESCARGA_HAWB")) {
      this.puedoDescargar = true;
    } else {
      this.puedoDescargar = false;
    }
  },
};
</script>
